import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { SidebarVisibilityService } from '../../services/sidebar-visibility.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css'],
  standalone: false
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  showSidebar = true;
  private subscriptions: Subscription[] = [];

  constructor(
    private sidebarVisibilityService: SidebarVisibilityService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // Initialize sidebar state
    this.showSidebar = this.sidebarVisibilityService.showSidebar;

    // Subscribe to visibility changes
    const visibilitySub = this.sidebarVisibilityService.onVisibilityChanged.subscribe(
      (visible) => {
        this.showSidebar = visible;
        this.cdr.detectChanges();
      }
    );
    this.subscriptions.push(visibilitySub);

    // Reset sidebar on navigation
    const routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.sidebarVisibilityService.showSidebar = true;
      }
    });
    this.subscriptions.push(routerSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}

